import {combineEpics} from 'redux-observable'
import {
    // logInRequestEpic,
    logOutEpic,
    logoutFromNats,
    setGlobalUserData,
} from './auth'
import {
    shopsRequestSuccessEpic,
    shopsSelectShopStorageEpic,
    shopsClearDataEpic,
    startInitiallyLoadingShopsEpic,
    shopsRequestStartEpic,
    changeNatsSubscriptionEpic,
    shopByIdRequestStartEpic,
    reloadShopRequestStartEpic,
    shopByIdRequestSuccessEpic,
    loadShopAdministratorEpic,
} from './shops'
import {
    botPollStatusEpic,
    botsClearDataEpic,
    botsLoadEpic,
    botsRequestStartEpic,
    botUpdateStatisticEpic,
    whatsappGetQRCodeEpic,
    whatsappLogoutRequestStartEpic,
    networkStateEpic,
} from './dashboard'
import {
    stepMovedEpic,
    updateFlowConfigEpic,
} from './steps'
import {
    loadBillingConfigEpic,
} from './billing'

import {
    addingNewContactRequestEpics,
    addingNewContactToggleModalEpics,
    importNewContactsRequestEpics,
    chatsClearDataEpic,
} from './chats'


export default combineEpics(
    // logInRequestEpic,
    logOutEpic,
    logoutFromNats,
    setGlobalUserData,

    startInitiallyLoadingShopsEpic,
    shopsRequestStartEpic,
    changeNatsSubscriptionEpic,
    shopsRequestSuccessEpic,
    shopsSelectShopStorageEpic,
    shopByIdRequestStartEpic,
    reloadShopRequestStartEpic,
    shopByIdRequestSuccessEpic,
    shopsClearDataEpic,
    updateFlowConfigEpic,
    loadShopAdministratorEpic,

    botsLoadEpic,
    botsRequestStartEpic,
    botsClearDataEpic,
    botUpdateStatisticEpic,
    botPollStatusEpic,
    whatsappGetQRCodeEpic,
    whatsappLogoutRequestStartEpic,
    networkStateEpic,

    stepMovedEpic,

    loadBillingConfigEpic,

    addingNewContactRequestEpics,
    addingNewContactToggleModalEpics,
    importNewContactsRequestEpics,
    chatsClearDataEpic,
)
